import { render, staticRenderFns } from "./smsRecord.vue?vue&type=template&id=2644567b&scoped=true"
import script from "./smsRecord.vue?vue&type=script&lang=js"
export * from "./smsRecord.vue?vue&type=script&lang=js"
import style0 from "./smsRecord.vue?vue&type=style&index=0&id=2644567b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644567b",
  null
  
)

export default component.exports